import { ControlAnimationMessage } from "flavr-common";
import { busService } from "../../bus";
import { resolveUid } from "../model/Utils";
const connection = busService.connection("ScriptAnimation");
export class ScriptAnimation {
    static play(uid) {
        connection.send(new ControlAnimationMessage(resolveUid(uid), "play"));
    }
    static pause(uid) {
        connection.send(new ControlAnimationMessage(resolveUid(uid), "pause"));
    }
    static reset(uid) {
        connection.send(new ControlAnimationMessage(resolveUid(uid), "reset"));
    }
    /** Selects a clip by name without changing saved defaults; null clears the selection. */
    static select(uid, clipName, occurrence = 0) {
        const clip = clipName === null ? null : { name: clipName, occurrence };
        connection.send(new ControlAnimationMessage(resolveUid(uid), "select", clip));
    }
}
